export const tools_Marketplaces = [
	{
		icon: '🎯',
		subtitle: 'toolsData_subtitle1',
	},
	{
		icon: '🎨',
		subtitle: 'toolsData_subtitle2',
	},
	{
		icon: '💁‍♀️',
		subtitle: 'toolsData_subtitle3',
	},
];
